module.exports = __webpack_public_path__ + "media/4.47056cd2.wav";